import { render, staticRenderFns } from "./purchasingUpdate.vue?vue&type=template&id=2b857581&scoped=true"
import script from "./purchasingUpdate.vue?vue&type=script&lang=js"
export * from "./purchasingUpdate.vue?vue&type=script&lang=js"
import style0 from "./purchasingUpdate.vue?vue&type=style&index=0&id=2b857581&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b857581",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b857581')) {
      api.createRecord('2b857581', component.options)
    } else {
      api.reload('2b857581', component.options)
    }
    module.hot.accept("./purchasingUpdate.vue?vue&type=template&id=2b857581&scoped=true", function () {
      api.rerender('2b857581', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/purchasingManagement/purchasingUpdate.vue"
export default component.exports